export default __webpack_public_path__ + "static/165-bdec9cd689e77c74eb3e593a3493fe53.jpg";